import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class CreateClaimDto {
  @Field(t => Int)
  arcId!: number

  @Field(t => Int)
  userId!: number

  @Field(t => Int, { nullable: true })
  selectedAudioSiteFlag?: number

  public constructor (data: CreateClaimDto) {
    Object.assign(this, data)
  }
}
